import React from 'react';

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import DeleteButton from "../Form/DeleteButton";
import i18n from "../../i18n";
import {FormattedNumber} from "react-intl";
import Grid from "@material-ui/core/Grid/Grid";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import MUIListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List/List";
import {Typography, withStyles} from "@material-ui/core";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import {getCategoryOption} from "../Form/utils";

const renderDetailsRow = (label, value, classes) => {
    return (
        <MUIListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={8}>
                    <ListItemText primary={(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)} className={classes.detailsLabel}/>
                </Grid>
                <Grid item xs={4}>
                    <ListItemText primary={value} className={classes.detailsValue}/>
                </Grid>
            </Grid>
        </MUIListItem>
    );
};

const getRateModel = (rateId, lifeCycleRates) => {
    let filtered = lifeCycleRates.filter((rate) => rate.id === rateId);
    if (filtered && filtered.length > 0) {
        return filtered.shift();
    }
    return null;
};


const ListItem = ({attribute, lifeCycleRates, categoryOptions, classes, intervalUnits}) => (
    <TableRow>
        <TableCell>
            {attribute.name}
        </TableCell>
        <TableCell>{attribute.localized_unit}</TableCell>
        <TableCell>
            {attribute.categories && lifeCycleRates ? (
                    <List>
                        {attribute.categories.map((item, category) => {
                            let lifeCycleRate = getRateModel(item.lifeCycleRate, lifeCycleRates);
                            let categoryOption = getCategoryOption(category, categoryOptions);
                            if (lifeCycleRate && categoryOption && lifeCycleRate.rate && lifeCycleRate.rate > 0) {
                                return renderDetailsRow(categoryOption.label, (
                                    <React.Fragment>
                                        <FormattedNumber title={lifeCycleRate.name} value={lifeCycleRate.rate / 100} style={"percent"} maximumFractionDigits={2}/>

                                        {item.interval > 0 && (
                                            <React.Fragment>
                                                <span>&nbsp;
                                                    ({intervalUnits.filter( iu => (item.interval_unit === iu.unit ) ).map( ui => (ui.name)).join('')}:&nbsp;
                                                    <FormattedNumber value={item.interval} style={"numeric"} maximumFractionDigits={0}/>)
                                                </span>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                ), classes);
                            }
                            return null;
                        })}
                    </List>
                )
                : attribute.rate_text}
        </TableCell>
        <TableCell>
            <IconButton
                component="a"
                href={`/attributes/${attribute.id}/edit`}
            >
                <Icon>edit</Icon>
            </IconButton>

            <DeleteButton
                confirmMessage={i18n.get('attribute.delete.confirm')}
                successMessage={i18n.get('attribute.delete.success')}
                errorMessage={i18n.get('attribute.delete.error')}
                href={`/attributes/${attribute.id}`}
            />
        </TableCell>
    </TableRow>
);

const styles = theme => ({
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: "100%",
    },
    detailsRow: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        "&:last-child": {
            padding: 0,
        }
    },
    detailsLabel: {
        textAlign: "right",
        padding: "0 3px",
    },
    detailsValue: {
        "& > *": {
            ...theme.helpers.oneLiner,
        },
        padding: "0 3px",
        color: theme.colors.black,
    },
});


export default withStyles(styles)(ListItem);
